import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/(pages)/account/page.tsx");
